<script>
export default {
  props: {
    farmId: { type: String, required: true },
  },

  data: () => ({
    campName: '',
  }),

  computed: {
    validationError() {
      if (!this.campName || this.campName.trim().length === 0) return 'Grazing camp name is required';

      return undefined;
    },
  },

  methods: {
    clearForm() {
      this.campName = '';
    },
  },
}
</script>

<template>
  <api-form
    method="post"
    :url="`v1/farms/${farmId}/grazings`"
    :payload="{camp_name: campName}"
    submit-text="Add"
    :validation-error="validationError"
    :make-success-message="() => `Grazing successfully added.`"
    @success="$emit('added', $event); clearForm();"
    @cancel="$emit('cancel')">

    <b-form-group label="Camp Name" :label-for="`camp-name-${_uid}`">
      <b-form-input :id="`camp-name-${_uid}`" v-model="campName" type="text" placeholder="Bravo camp..." required @focus="$event.target.select()"></b-form-input>
    </b-form-group>

  </api-form>
</template>



// WEBPACK FOOTER //
// src/grazing/components/GrazingAddForm.vue